import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	depTableNames: [],
	depTableSettings: {},
	edit: {
		DepartmentName: null as string | null,
		Description: null as string | null,
		InvoiceDepartmentId: null as number | null,
	},
	localState: {},
	props: {
		mode: null,
	},
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
});
